const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://sf.api.sipremo.com/api/acm";

export const API_ROUTE = {
  AUTH: `${BASE_URL}/get_user`,
  GET_REGIONS: (enterprise = "ACM") =>
    `${BASE_URL}/regions/region?enterprise=${encodeURIComponent(enterprise)}`,
  GET_PLOT: (enterprise = "ACM") =>
    `${BASE_URL}/plots_all_regions?enterprise=${encodeURIComponent(enterprise)}`,
  GET_PREDICTION: (enterprise = "ACM") =>
    `${BASE_URL}/prediction/?enterprise=${encodeURIComponent(enterprise)}`,
  CREATE_REGISTRY: `${BASE_URL}/registry/registry/`,
};

export default BASE_URL;
